
    <nav class="navbar box-shadow app-header" [class.fixed-top]="settings.theme.navbarIsFixed" [class.logo-visible]="showInfoContent">
        <div class="d-flex flex-column w-100">
            <div id="info-content" class="panel-collapse collapse">
                <a class="close" data-toggle="collapse" href="#info-content" (click)="showInfoContent = !showInfoContent" [class.show]="showInfoContent">
                    <span aria-hidden="true">&times;</span>
                </a>
                <div class="row align-items-center">
                    <div class="col-md-5">
                        <div class="d-flex justify-content-center align-items-center pt-md-0 pt-3 info">
                            <div class="d-flex flex-column pl-3">
                                <h5 class="mb-0">Logicor Admin <i class="fa fa-check-circle fs-13 text-success ml-2"></i></h5>
                                <span>Web Superadmin</span>
                                <div class="pt-3">
                                    <button class="btn btn-success">Profile</button> 
                                </div>                            
                            </div>
                        </div>
                    </div>
                    <div class="col-md-7">
                        <div class="row py-4">                        
                            <div class="col-lg-7 col-sm-8 col-12 left-border">
                                <div class="info w-280p mx-auto text-center">
                                    <form>
                                        <div class="form-group">
                                            <input type="text" class="form-control form-control-sm" placeholder="Recipients">
                                        </div>
                                        <div class="form-group">
                                            <input type="text" class="form-control form-control-sm" placeholder="Subject">
                                        </div>
                                        <div class="form-group">
                                            <textarea class="form-control form-control-sm" placeholder="Message" rows="3"></textarea>
                                        </div>
                                        <button type="submit" class="btn btn-sm btn-gray"><i class="fa fa-paper-plane mr-2"></i>Send</button>
                                    </form>
                                </div>                           
                            </div>
    
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-start align-items-center top-navbar">                  
                
               
                <a class="logo" routerLink="/" (click)="closeSubMenus()">
                    <span class="start"></span><span class="ng"><img src="assets/img/app/header_icon.png"> </span>
                </a>
                <span class="navbar-text menu-icon transition ml-3 mr-3" [ngClass]="{'open': settings.theme.showMenu}"
                    (click)="settings.theme.showMenu = !settings.theme.showMenu">
                    <div class="line"></div>
                    <div class="line"></div>
                    <div class="line"></div>
                    <div class="line"></div>
                </span>

                <app-search></app-search>
    
                <div class="top-rigth-icons ml-auto">
                    <!-- <button class="btn btn-round btn-warning" *ngIf="checkOfUpdatedVersion()" (click)="refresh()" ngbTooltip="You are now viewing an old version of iDrv. To avoid encountering issues, click to refresh browser and re-login."><strong>New iDrv version is available! </strong></button>  -->
                    <span class="hidden-xs-down">
                     <app-tasknotifications></app-tasknotifications> 
                    </span>
                    <span class="hidden-xs-down">
                        <app-user-menu></app-user-menu>
                    </span> 
                </div> 
            </div>
    
            <div class="horizontal-menu-outer" *ngIf="settings.theme.menu == 'horizontal'">   
                <app-horizontal-menu *ngIf="showHorizontalMenu"  [menuItems]="menuItems"></app-horizontal-menu>        
            </div>
        </div>
    </nav>

<!-- START OF VERSION MODAL  -->
<ng-template #modalVersion>
    <div class="modal-header">
        <h5 class="modal-title"><i class="fa fa-lg fa-warning text-danger"></i>New iDrv Version Available! <span class="text-success">{{new_version}}</span></h5>
    </div>
    <div class="modal-body">
        <strong>You are being logged out to this browser in <b class="text-warning">{{logout_count}}</b> <i class="fa fa-spinner fa-spin text-warning"></i> , as we detected that you are viewing an old version [<span class="text-warning">{{local_version}}</span>] of iDrv. Kindly make sure to close multiple instances of iDrv browsers before logging back in. Thank you!</strong>&nbsp;
    </div>
</ng-template>
<!-- END OF VERSION MODAL MODAL  -->




 